(() => {
  const effect = document.querySelector('[data-rim-transition]');
  if (!effect || window.Shopify?.designMode) return;
  const key = 'marcos:rim-navigation';
  const duration = 550;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const isRims = (url) => url.origin === location.origin && /\/collections\/rims\/?$/i.test(url.pathname);
  let timer;
  let navigating = false;
  const hide = () => {
    clearTimeout(timer);
    effect.hidden = true;
  };
  const show = (elapsed = 0) => {
    if (reduced.matches || elapsed >= duration) return;
    effect.style.setProperty('--rim-transition-delay', `${-Math.max(0, elapsed)}ms`);
    effect.hidden = false;
    clearTimeout(timer);
    timer = setTimeout(hide, duration - Math.max(0, elapsed));
  };

  let arrival;
  try {
    arrival = JSON.parse(sessionStorage.getItem(key) || 'null');
    sessionStorage.removeItem(key);
  } catch (_) { /* Navigation still works when browser storage is unavailable. */ }
  const elapsed = Date.now() - Number(arrival?.started);
  if (!reduced.matches && isRims(new URL(location.href)) && arrival?.path === location.pathname && elapsed >= 0 && elapsed < 5000) {
    show(elapsed);
    document.documentElement.classList.add('rim-navigation-arrival');
    setTimeout(() => document.documentElement.classList.remove('rim-navigation-arrival'), 220);
  }

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || reduced.matches) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const destination = new URL(link.href, location.href);
    if (!isRims(destination)) return;
    if (destination.pathname === location.pathname && destination.search === location.search) return;
    // Leave the browser's link behavior untouched: there is no artificial loading wait.
    navigating = true;
    try { sessionStorage.setItem(key, JSON.stringify({ path: destination.pathname, started: Date.now() })); } catch (_) { /* Optional effect. */ }
    link.closest('header-drawer')?.close?.();
    show();
  });

  // Avoid stacking the theme's generic page transition over this short, collection-specific effect.
  window.addEventListener('pageswap', (event) => {
    if (navigating) event.viewTransition?.skipTransition();
  });
  window.addEventListener('pagehide', hide);
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    hide();
    navigating = false;
    document.documentElement.classList.remove('rim-navigation-arrival');
    try { sessionStorage.removeItem(key); } catch (_) { /* Optional effect. */ }
  });
  reduced.addEventListener('change', () => { if (reduced.matches) hide(); });
})();
